document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("galleryTrack");
  const wrapper = document.getElementById("galleryWrapper");

  if (!track || !wrapper) return;

  let position = 0;
  const speed = 0.5;
  let paused = false;
  let stopAnimation = false;

  // Hover-Pause bei Desktop
  wrapper.addEventListener("mouseover", e => {
    if (e.target.tagName === "IMG") paused = true;
  });

  wrapper.addEventListener("mouseout", e => {
    if (e.target.tagName === "IMG") paused = false;
  });

  // Animation pausieren bei Tab-Wechsel
  document.addEventListener("visibilitychange", () => {
    stopAnimation = document.hidden;
  });

  // Animation starten
  function animate() {
    if (!paused && !stopAnimation) {
      position += speed;
      if (position >= track.scrollWidth / 2) {
        position = 0;
      }
      track.style.transform = `translateX(-${position}px)`;
    }
    requestAnimationFrame(animate);
  }

  animate();
});
